<template>
  <q-page-container>
    <q-page> <slot /> </q-page>
  </q-page-container>
</template>
